import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { UserActiveBaseComponent } from '@luggagehero/features/bookings';
import { UserActiveService } from '@luggagehero/services';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'lh-user-active-booking',
  templateUrl: './user-active.component.html',
  styleUrls: ['./user-active.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserActiveComponent extends UserActiveBaseComponent {
  @ViewChild('userActiveModal') public userActiveModal: ModalDirective;

  public constructor(userActiveService: UserActiveService, windowService: SharedWindowService, cd: ChangeDetectorRef) {
    super(userActiveService, windowService, cd);
  }

  showRefreshPrompt(): Promise<void> {
    return void this.userActiveModal.show();
  }

  hideRefreshPrompt(): Promise<void> {
    return void this.userActiveModal.hide();
  }
}
